var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVanilla = function SvgVanilla(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vanilla_svg__a)",
    d: "M43.585 199c2.182 0 8.6-3.5 9.684-5.183s66.22-32.3 85.282-43.515 58.889-48.458 62.157-52.556 20.7-22.662 22.758-22.662 6.052 1.206 6.779 2.29 3.268 0 2.663-3.254-10.169-3.616-12.59-2.652-41.157 26.278-42.851 27.845-13.2 13.5-17.553 15.188-51.688 33.028-58.225 35.921-53.867 28.689-55.925 30.738-3.874 4.942-5.63 5.6c-1.754.658-3.65 4.2-3.005 6.529S39.549 199 43.585 199"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vanilla_svg__a",
    x1: 37,
    x2: 233,
    y1: 135,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#238DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3C9AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#64AED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#9BCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#E0EFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgVanilla;